<script setup lang="ts">
import { computed, watch } from "vue"
import { storeToRefs } from "pinia"
import { useEpciCommuneStore, useOnlineStore, useUserStore } from "~/store"

const epciCommuneStore = useEpciCommuneStore()
const userStore = useUserStore()
const onLineStore = useOnlineStore()

const { epciCommunes, currentEpciCommune, loading } = storeToRefs(epciCommuneStore)
const { user } = storeToRefs(userStore)
const { online } = storeToRefs(onLineStore)

// epciCommuneStore.initCurrentEpciCommune()
epciCommuneStore.fetchEpciCommunes()

const formattedEpciCommunes = computed(() => {
    return epciCommunes.value.map(commune => ({
        id: commune.id,
        title: commune.v,
        fullObject: commune,
    }))
})

const isAdmin = computed(() => user.value?.role === "admin")
const hasAssociatedEpciCommune = computed(() => epciCommunes.value?.length > 1)
const selected = computed({
    get: () => {
        return formattedEpciCommunes.value.find(item => item.fullObject.id === currentEpciCommune.value?.id) || null
    },
    set: (value) => {
        epciCommuneStore.setSelectedEpciCommune(value?.fullObject || null)
    },
})

watch(user, (newVal) => {
    if (newVal && newVal.k) {
        epciCommuneStore.fetchEpciCommunes()
    }
})
</script>

<template>
    <template v-if="user?.id">
        <template v-if="hasAssociatedEpciCommune">
            <v-autocomplete
                v-model="selected"
                :disabled="!online || !hasAssociatedEpciCommune"
                :bg-color="selected ? 'secondary' : ''"
                color="primary"
                base-color="primary"
                class="ma-4 selection-item"
                density="compact"
                :items="formattedEpciCommunes"
                item-value="id"
                item-title="title"
                :loading="loading"
                variant="outlined"
                placeholder="Epci ou commune"
                :clearable="isAdmin"
                return-object
                hide-details
                @update:model-value="useRouter().push('/')"
            />
        </template>
        <div v-else class="text-h5 font-weight-bold pa-2 w-25 text-secondary">
            {{ currentEpciCommune?.name || "Aucun EPCI ou Commune sélectionné" }}
        </div>
    </template>
</template>
